import { useSelector }  from "react-redux";
import Count            from "../../../../domain/fundamentals/count/Count";
import { ResKaState }   from "../../../../index";
import ResKaReduxAction from "../../ResKaReduxAction";

enum ReservationCancelRequestCountActionType {
  INIT_RESERVATION_CANCEL_REQUEST_COUNT = "INIT_RESERVATION_CANCEL_REQUEST_COUNT",
  SET_RESERVATION_CANCEL_REQUEST_COUNT = "SET_RESERVATION_CANCEL_REQUEST_COUNT",
}

interface InitReservationCancelRequestCountAction extends ResKaReduxAction {
}

interface SetReservationCancelRequestCountAction extends ResKaReduxAction {
  count: Count;
}

type ReservationCancelRequestCountAction =
  InitReservationCancelRequestCountAction
  | SetReservationCancelRequestCountAction;

export const initReservationCancelRequestCountAction = (): InitReservationCancelRequestCountAction => ({
  type: ReservationCancelRequestCountActionType.INIT_RESERVATION_CANCEL_REQUEST_COUNT,
});

export const setReservationCancelRequestCountAction = (count: Count): SetReservationCancelRequestCountAction => ({
  type: ReservationCancelRequestCountActionType.SET_RESERVATION_CANCEL_REQUEST_COUNT,
  count: count,
});

export const reservationCancelRequestCountReducer = (state: Count = new Count(), action: ReservationCancelRequestCountAction): Count => {
  switch (action.type) {
    default:
      return state;
    case ReservationCancelRequestCountActionType.INIT_RESERVATION_CANCEL_REQUEST_COUNT:
      return new Count();
    case ReservationCancelRequestCountActionType.SET_RESERVATION_CANCEL_REQUEST_COUNT:
      return (action as SetReservationCancelRequestCountAction).count;
  }
}

export const useReservationCancelRequestCount = (): Count => useSelector((state: ResKaState) => state.reservationCancelRequestCount);
